import {
  UserRegistrationConfirmationTokenVaultActions,
  UserSmsTokenVaultActions,
  UserTwoFATokenVaultActions,
} from '../token-vault';

export type SmsActions =
  | UserSmsTokenVaultActions
  | UserTwoFATokenVaultActions
  | UserRegistrationConfirmationTokenVaultActions.USER_REGISTRATION_MOBILE_CONFIRMATION;

export const AllSmsActions = {
  ...UserSmsTokenVaultActions,
  ...UserTwoFATokenVaultActions,
  USER_MOBILE_CONFIRMATION:
    UserRegistrationConfirmationTokenVaultActions.USER_REGISTRATION_MOBILE_CONFIRMATION,
} as const;
